export const RadnoVrijemeSumEvdResourceDE: RadnoVrijemeSumEvdInterface = {
  title: "Arbeitszeitliste",
  errors: {
    query:
      "Beim Laden der Benutzer ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
  },
  inputFields: {
    branch: {
      placeholder: "Filiale auswählen",
      notFound: "Keine Filiale gefunden",
    },
    endDate: {
      label: "Enddatum",
    },
    startDate: {
      label: "Startdatum",
    },
    user: {
      error: "Bitte wählen Sie einen Benutzer aus",
      label: "Benutzer auswählen",
      name: "user",
      placeholder: "Benutzer auswählen",
    },
  },
  pdf: {
    button: "PDF herunterladen",
    document: {
      name: "Vor- und Nachname",
      title: "Arbeitszeitnachweis",
      odabraniPeriod: "Ausgewählter Zeitraum",
      ukupnoVrijeme: "Gesamtstunden",
      potpisFooter: "Unterschrift",
      upisaoFooter: "Genehmigt von",
      entryType: "Evidenztyp",
      napomena: "Notiz",
      pocetak: "Beginn",
      pocetakPauze: "Pausenbeginn",
      potpisano: "Unterschrift",
      zavrsetak: "Ende",
      zavrsetakPauze: "Pausenende",
      tipovi: {
        DEZURA: "Bereitschaftsdienst",
        ODSUSTVO: "Abwesenheit",
        PRIPRAVNOST: "Bereitschaft",
        RADNOVRIJEME: "Arbeitszeit",
        RADUSMJENAMA: "Schichtarbeit",
        TERENSKIRAD: "Außendienstarbeit",
        BOLOVANJE: "Krankenstand",
        SLOBODANDAN: "Freier Tag",
      },
    },
  },
  sihtarica: {
    periodLabel: "Zeitraum (Monat)",
    statusOpen: "Offen",
    statusLocked: "Gesperrt",
    statusApproved: "Genehmigt",
    lock: "Genehmigen / Sperren",
    approveSelected: "Auswahl genehmigen",
    approveNoneSelected: "Wählen Sie mindestens einen Eintrag zur Genehmigung.",
    approvedOk: "Ausgewählte Einträge wurden genehmigt.",
    unapprove: "Genehmigung aufheben",
    unapproveOk: "Genehmigung wurde aufgehoben.",
    reopen: "Erneut öffnen",
    viewByWorker: "Nach Mitarbeitern",
    viewByDay: "Nach Tagen",
    batchEdit: "Sammeländerung",
    edit: "Bearbeiten",
    delete: "Löschen",
    deleteConfirm: "Möchten Sie diesen Eintrag wirklich löschen?",
    deleteOk: "Eintrag gelöscht.",
    addEntry: "Eintrag hinzufügen",
    addEntryTitle: "Arbeitszeit hinzufügen",
    save: "Speichern",
    cancel: "Abbrechen",
    editReason: "Änderungsgrund",
    editReasonRequired: "Änderungsgrund ist erforderlich.",
    pdfOnlyLocked:
      "PDF kann erst heruntergeladen werden, wenn der Zeitraum gesperrt ist.",
    lockedOk: "Zeitraum gesperrt.",
    reopenedOk: "Zeitraum erneut geöffnet.",
    editOk: "Änderung gespeichert.",
    addOk: "Eintrag hinzugefügt.",
    batchOk: "Sammeländerung gespeichert.",
    actionError: "Aktion fehlgeschlagen.",
    errorDuplicateEntry:
      "Für diesen Tag existiert bereits ein Eintrag mit demselben Typ und denselben Zeiten. Tip oder Zeiten ändern.",
    empty: "Keine Einträge für den ausgewählten Zeitraum.",
    totalHours: "Gesamt",
    deviation: "Überschreitung",
    colDate: "Datum",
    colWorker: "Mitarbeiter",
    colType: "Typ",
    colIn: "Kommen",
    colOut: "Gehen",
    colHours: "Stunden",
    colNote: "Notiz",
  },
};

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

export interface RadnoVrijemePDFSumInterface {
  name: string;
  title: string;
  odabraniPeriod: string;
  potpisFooter: string;
  upisaoFooter: string;
  entryType: string;
  pocetak: string;
  zavrsetak: string;
  pocetakPauze: string;
  zavrsetakPauze: string;
  napomena: string;
  potpisano: string;
  ukupnoVrijeme: string;
  tipovi: {
    RADNOVRIJEME: string;
    RADUSMJENAMA: string;
    TERENSKIRAD: string;
    DEZURA: string;
    PRIPRAVNOST: string;
    ODSUSTVO: string;
    BOLOVANJE: string;
    SLOBODANDAN: string;
  };
}

export interface RadnoVrijemeSumEvdInterface {
  title: string;
  errors: {
    query: string;
  };
  inputFields: {
    branch: {
      placeholder: string;
      notFound: string;
    };
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    user: InputFieldInterface;
  };
  pdf: {
    button: string;
    document: RadnoVrijemePDFSumInterface;
  };
  sihtarica: {
    periodLabel: string;
    statusOpen: string;
    statusLocked: string;
    statusApproved: string;
    lock: string;
    approveSelected: string;
    approveNoneSelected: string;
    approvedOk: string;
    unapprove: string;
    unapproveOk: string;
    reopen: string;
    viewByWorker: string;
    viewByDay: string;
    batchEdit: string;
    edit: string;
    delete: string;
    deleteConfirm: string;
    deleteOk: string;
    addEntry: string;
    addEntryTitle: string;
    save: string;
    cancel: string;
    editReason: string;
    editReasonRequired: string;
    pdfOnlyLocked: string;
    lockedOk: string;
    reopenedOk: string;
    editOk: string;
    addOk: string;
    batchOk: string;
    actionError: string;
    errorDuplicateEntry: string;
    empty: string;
    totalHours: string;
    deviation: string;
    colDate: string;
    colWorker: string;
    colType: string;
    colIn: string;
    colOut: string;
    colHours: string;
    colNote: string;
  };
}
